var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlockFill(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 -960 960 960",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480-65.869q-85.826 0-161.37-32.63-75.543-32.631-131.804-88.892-56.261-56.261-88.61-131.804Q65.87-394.739 65.87-481.13q0-85.261 32.63-160.805 32.631-75.544 88.609-131.522 55.979-55.978 131.522-88.609 75.544-32.63 161.37-32.63 85.826 0 161.37 32.63 75.543 32.631 131.522 88.609 55.978 55.978 88.891 131.522 32.913 75.544 32.913 160.805 0 86.391-32.63 161.935-32.631 75.543-88.892 131.804-56.261 56.261-131.804 88.892Q565.826-65.87 480-65.87Zm0-79.218q57.622 0 111.571-18.239 53.95-18.239 96.689-55.544L217.739-688.26q-35.174 43.739-53.913 97.081-18.739 53.343-18.739 110.049 0 140.679 97.4 238.361Q339.886-145.087 480-145.087Zm261.826-128.348q33.044-43.305 53.065-96.689 20.022-53.385 20.022-111.006 0-139.549-97.4-236.666Q620.114-814.913 480-814.913q-57.271 0-110.048 18.457Q317.174-778 272.87-742.391l468.956 468.956Z"
  })));
}
export default __webpack_public_path__ + "media/outlined/block-fill-55bfcb51.svg";
export { SvgBlockFill as ReactComponent };